import { fromJS } from "immutable"
import { TYPE_SURVEY } from "../../../utils/constants"
import { validate } from "../../../utils/functions"
import { KEY_ISOLATED_METRICS, setItem } from "../../../utils/storage"
import {
  GET_STATUS_WATCHER,
  GET_STATUS_SUCCESS,
  GET_STATUS_FAILED,
  GET_MEASURE_COLOR_RANGE_WATCHER,
  GET_MEASURE_COLOR_RANGE_SUCCESS,
  GET_MEASURE_COLOR_RANGE_FAILED,
  GET_MEASURE_TOTAL_WATCHER,
  GET_MEASURE_TOTAL_SUCCESS,
  GET_MEASURE_TOTAL_FAILED,
  GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER,
  GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS,
  GET_MEASURE_TOTAL_SUB_DIVISION_FAILED,
  GET_MEASURE_INFO_WATCHER,
  GET_MEASURE_INFO_SUCCESS,
  GET_MEASURE_INFO_FAILED,
} from "./constants"

export const initialState = fromJS({
  isLoading: false,
  measureColorRange: [],
  isMeasureProcess: false,
  dimensionsBottom: [],
  dimensionsTop: [],
  divisionsAvailable: [],
  divisionsData: {},
  measureGeneral: null,
  measureTotal: null,
  userType: null,
  isLoadingTab: false,
  isLoadingSubDivision: false,
  measureInfo: null,
})

function reportAmbassadorV2Reducer(state = initialState, action) {
  switch (action.type) {
    // Si cambia la medición se limpia el estado: si no, los widgets usan datos de la anterior (VLENG-12055).
    // Dentro de la misma medición (cambio de división/segmento) se conserva.
    case GET_STATUS_WATCHER: {
      setItem(KEY_ISOLATED_METRICS, false)
      const currentMeasure = state.get("measureGeneral")
      const isOtherMeasure =
        !currentMeasure || currentMeasure.id_measure !== action.payload.id_measure
      const loadingState = state.set("isLoading", true)
      return isOtherMeasure
        ? loadingState
            .set("measureGeneral", null)
            .set("measureTotal", null)
            .set("typeMeasurement", null)
        : loadingState
    }

    case GET_STATUS_SUCCESS: {
      setItem(
        KEY_ISOLATED_METRICS,
        action.payload.measureGeneral.has_isolated_metrics || false
      )
      let typeMeasurement = null
      if (
        action.payload.measureGeneral.id_survey_type ===
        TYPE_SURVEY.leadership.idSurveyType
      ) {
        typeMeasurement = TYPE_SURVEY.leadership.slugSurveyType
      } else {
        typeMeasurement = action.payload.measureGeneral.is_engagement
          ? TYPE_SURVEY.engagement.slugSurveyType
          : TYPE_SURVEY.climate.slugSurveyType
      }
      return state
        .set("isLoading", false)
        .set(
          "isMeasureProcess",
          !!(action.payload.measureTotal && action.payload.measureTotal.percent)
        )
        .set("dimensionsBottom", action.payload.dimensions_bottom)
        .set("dimensionsTop", action.payload.dimensions_top)
        .set("divisionsAvailable", action.payload.divisionsAvailable)
        .set("divisionsData", action.payload.divisionsData)
        .set("measureTotal", action.payload.measureTotal)
        .set("measureGeneral", action.payload.measureGeneral)
        .set("isErrorStatus", false)
        .set("typeMeasurement", typeMeasurement)
        .set("userType", action.payload.userType)
    }

    case GET_STATUS_FAILED:
      return state
        .set("isLoading", false)
        .set("isMeasureProcess", false)
        .set("divisionsAvailable", [])
        .set("divisionsData", {})
        .set("isolatedMetrics", false)
        .set("measureGeneral", null)
        .set("measureTotal", null)
        .set("isErrorStatus", true)
        .set("userType", null)

    case GET_MEASURE_COLOR_RANGE_WATCHER:
      return state
    case GET_MEASURE_COLOR_RANGE_SUCCESS:
      return state.set(
        "measureColorRange",
        validate.exist(action.payload.report_color_range)
          ? action.payload.report_color_range
          : []
      )
    case GET_MEASURE_COLOR_RANGE_FAILED:
      return state.set("measureColorRange", [])

    case GET_MEASURE_TOTAL_WATCHER:
      return state.set("isLoadingTab", true)
    case GET_MEASURE_TOTAL_SUCCESS:
      return state
        .set("isLoadingTab", false)
        .set("measureTotal", action.payload.measureTotal)
        .set(
          "isMeasureProcess",
          !!(action.payload.measureTotal && action.payload.measureTotal.percent)
        )
        .set("userType", action.payload.userType)
        .set("divisionsAvailable", action.payload.divisionsAvailable)
    case GET_MEASURE_TOTAL_FAILED:
      return state
        .set("isLoadingTab", false)
        .set("measureTotal", null)
        .set("isMeasureProcess", false)
        .set("divisionsAvailable", [])

    case GET_MEASURE_TOTAL_SUB_DIVISION_WATCHER:
      return state.set("isLoadingSubDivision", true)
    case GET_MEASURE_TOTAL_SUB_DIVISION_SUCCESS:
      return state
        .set("isLoadingSubDivision", false)
        .set("measureTotal", action.payload.resultTotal)
        .set(
          "isMeasureProcess",
          !!(action.payload.resultTotal && action.payload.resultTotal.percent)
        )
    case GET_MEASURE_TOTAL_SUB_DIVISION_FAILED:
      return state
        .set("isLoadingSubDivision", false)
        .set("measureTotal", null)
        .set("isMeasureProcess", false)

    case GET_MEASURE_INFO_WATCHER:
      return state
    case GET_MEASURE_INFO_SUCCESS:
      return state.set("measureInfo", action.payload.measureInfo)
    case GET_MEASURE_INFO_FAILED:
      return state.set("measureInfo", null)

    default:
      return state
  }
}

export default reportAmbassadorV2Reducer
